import { Chip, SvgIconProps, alpha } from "@mui/material"
import { orange, green, yellow } from "@mui/material/colors"
import { Workflow } from "../../../enums/orders"
import { DriverInvoiceState, DriverInvoiceType } from "../../../interfaces/common/driver-invoices"
import { chipPadding, chipOpacity } from "./common"
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { HourglassEmpty, CheckCircle } from "@mui/icons-material";



export const showDriverInvoiceType = (invoicetype: DriverInvoiceType): JSX.Element => {
    return (
        <Chip
            label={invoicetype.toLocaleLowerCase()}
            icon={invoicetype === DriverInvoiceType.DELIVERY ? <LocalShippingIcon /> : <LocalShippingIcon />}
            variant="filled"
            style={{
                padding: chipPadding,
                backgroundColor: invoicetype === DriverInvoiceType.PICKUP ? alpha(yellow[400], chipOpacity) : alpha(green[400], chipOpacity),
            }
            }
        />
    )
}


export const getDriverInvoiceStateColor = (state: DriverInvoiceState): string => {
    switch (state) {
        case DriverInvoiceState.PENDING_PAYMENT:
            return alpha(yellow[700], chipOpacity);
        case DriverInvoiceState.PAID:
            return alpha(green[500], chipOpacity);
        default:
            return alpha(yellow[500], chipOpacity);
    }
};

export const getDriverInvoiceStateIcon = (state: DriverInvoiceState): JSX.Element => {
    const iconProps: SvgIconProps = { fontSize: "small", color: "inherit" };

    switch (state) {
        case DriverInvoiceState.PENDING_PAYMENT:
            return <HourglassEmpty {...iconProps} />;
        case DriverInvoiceState.PAID:
            return <CheckCircle {...iconProps} />;
    }
};

export const showDriverInvoiceState = (state: DriverInvoiceState): JSX.Element => {
    return (
        <Chip
            icon={getDriverInvoiceStateIcon(state)}
            label={<b>{state.toString().replaceAll("_", " ")}</b>}
            variant="filled"
            style={{
                margin: 4,
                padding: chipPadding,
                backgroundColor: getDriverInvoiceStateColor(state),
            }}
        />
    );
};